module.exports = __webpack_public_path__ + "media/images/favicon-bbdfa3a0.ico";